<template>
  <div>
    <div align="left">
      <br />
      <br />
      <h4 class="mb-1 text-primary font-weight-bold">
        Daftar Customer - {{ items.name }}
      </h4>
      <br />
      <br />
    </div>
    <b-card class="text-left">
      <br />
      <b-row>
        <b-col class="pl-5">
          <h6>
            <router-link
              :to="{ name: 'BigCustomerList' }"
              class="text-primary h4 text-decoration-none"
            >
              <i class="fas fa-long-arrow-alt-left mr-2"></i>Kembali
            </router-link>
          </h6>
          <br />
          <h4 class="font-weight-bold">Data Pelamar</h4>
          <br />
        </b-col>
      </b-row>
      <div v-if="loading" class="d-flex justify-content-center mb-3">
        <b-spinner
          style="width: 3rem; height: 3rem"
          label="Loading..."
        ></b-spinner>
      </div>
      <b-row v-else>
        <b-col id="print" md="8" class="pl-5">
          <b-row>
            <b-col md="5">Nama Lengkap</b-col>
            <b-col md="7" class="font-weight-bold mb-3">{{ items.name }}</b-col>
            <b-col md="5">Alamat Lengkap</b-col>
            <b-col md="7" class="font-weight-bold mb-3">{{
              items.address
            }}</b-col>
            <b-col md="5">Kota Asal</b-col>
            <b-col md="7" class="font-weight-bold mb-3">{{
              items.origin_city
            }}</b-col>
            <b-col md="5">Kota Tujuan</b-col>
            <b-col md="7" class="font-weight-bold mb-3">{{
              items.destination_city
            }}</b-col>
            <b-col md="5">Nomor Telepon 1</b-col>
            <b-col md="7" class="font-weight-bold">{{ items.phone_number_one }}</b-col>
            <b-col md="5">Nomor Telepon 2</b-col>
            <b-col md="7" class="font-weight-bold">{{ items.phone_number_two }}</b-col>
            <b-col md="5">Alamat Email </b-col>
            <b-col md="7" class="font-weight-bold mb-3">{{
              items.email
            }}</b-col>
          </b-row>
          <br />
        </b-col>
        <b-col md="4">
          <b-card class="text-left bg-gray-100">
            <b-row>
              <b-col class="text-left" md="12">
                <b-form-group
                  id="fieldset-1"
                  label="Status"
                  class="mb-0"
                  label-for="input-1"
                >
                  <!-- <b-form-select
                    @change="changeStatus"
                    :value="items.status"
                    class="my-0"
                    :disabled="!editClaim"
                    :class="items.status === 'new' ? 'text-warning':'' || items.status === 'on review' ? 'text-info':''|| items.status === 'resolved' ? 'text-primary':''|| items.status === 'rejected' ? 'text-danger':'' "
                    id="input-1"
                  >
                    <option value="new" class="text-warning">New</option>
                    <option value="on review" class="text-info">On Review</option>
                    <option value="resolved" class="text-primary">Resolved</option>
                    <option value="rejected" class="text-danger">Rejected</option>
                  </b-form-select>-->
                  <select-status
                    v-model="items.status"
                    :editClaim="editClaim"
                  ></select-status>
                </b-form-group>
              </b-col>
            </b-row>
            <br />
            <b-row>
              <b-col md="8">
                <b>Applied Date</b>
                <p>{{ items.created_at | DateTime }}</p>
              </b-col>
            </b-row>
          </b-card>
          <br />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import selectStatus from "./SelectStatus";
import axios from "axios";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { mixInCkeditor } from "@/mixin/mixInCkeditor";

export default {
  mixins: [mixInCkeditor],
  components: {
    selectStatus: selectStatus,
  },
  data() {
    return {
      editor: ClassicEditor,
      items: [],
      loading: true,
      session: this.$session.get("jwt"),
      url_detail: window.location.href,
    };
  },
  beforeCreate() {
    this.$store.dispatch(
      "PaxelBigCustomerModule/getPaxelBigCustomer",
      this.$route.params.id
    );
  },
  mounted() {
    // Set the initial number of items
    this.$store.watch(
      (state) => state.PaxelBigCustomerModule.paxel_big_customer_id,
      (newValue, oldValue) => {
        this.items = newValue;
        // Do whatever makes sense now
        if (this.items.length === 0) {
          this.loading = true;
        } else {
          this.loading = false;
        }
      }
    );
    this.$store.watch(
      (state) => state.item_type,
      (newValue, oldValue) => {
        this.item_type = newValue;
      }
    );
  },
  methods: {
    refresh() {
      this.$store.dispatch("PaxelBigCustomerModule/getPaxelBigCustomer", this.$route.params.id);
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.slide-enter-active {
  -moz-transition-duration: 0.5s;
  -webkit-transition-duration: 0.5s;
  -o-transition-duration: 0.5s;
  transition-duration: 0.5s;
  -moz-transition-timing-function: ease-in;
  -webkit-transition-timing-function: ease-in;
  -o-transition-timing-function: ease-in;
  transition-timing-function: ease-in;
}

.slide-leave-active {
  -moz-transition-duration: 0.5s;
  -webkit-transition-duration: 0.5s;
  -o-transition-duration: 0.5s;
  transition-duration: 0.5s;
  -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to,
.slide-leave {
  max-height: 1000px;
  overflow: hidden;
}

.slide-enter,
.slide-leave-to {
  overflow: hidden;
  max-height: 0;
}
</style>
